import "./src/css/custom.scss";
import { initCookiePolicy } from "./src/utility/onetrust";
import { preload } from "./src/utility/search";

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  // Se non sto cambiando pagina non aggiornare la scroll position
  if (
    prevRouterProps?.location?.pathname === routerProps?.location?.pathname &&
    !routerProps?.location?.hash
  ) {
    return false;
  }
};

export const onClientEntry = () => {
  preload(null, {
    filters: {
      type: "event",
    },
    sort: {
      date: "desc",
    },
  });
};

export const onRouteUpdate = () => {
  // Inizializza la cookie policy di OneTrust
  initCookiePolicy();
};
